import React, { useState } from "react";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";
import { Input } from "@/components/ui/input";
import { periodPresets } from "@/lib/periods";

export function PeriodFilter({ value, onChange }) {
  const presets = periodPresets();
  const [mode, setMode] = useState("this");
  const apply = (key) => {
    setMode(key);
    if (key === "custom") return;
    const p = presets.find((x) => x.key === key);
    if (p) onChange({ from: p.from, to: p.to });
  };
  return (
    <div className="flex flex-wrap gap-2 items-center">
      <Select value={mode} onValueChange={apply}>
        <SelectTrigger className="w-[180px]" data-testid="period-filter"><SelectValue /></SelectTrigger>
        <SelectContent>
          {presets.map((p) => <SelectItem key={p.key} value={p.key}>{p.label}</SelectItem>)}
          <SelectItem value="custom">Período personalizado</SelectItem>
        </SelectContent>
      </Select>
      {mode === "custom" && (
        <>
          <Input type="date" value={value.from} onChange={(e) => onChange({ ...value, from: e.target.value })} className="w-[150px]" data-testid="period-from" />
          <span className="text-muted-foreground text-sm">até</span>
          <Input type="date" value={value.to} onChange={(e) => onChange({ ...value, to: e.target.value })} className="w-[150px]" data-testid="period-to" />
        </>
      )}
    </div>
  );
}
